import { useEffect, useRef } from 'react';
import { useCEProductSelector } from '../../bitf-customization-engine/useCEProductSelector';
export default function CEProductCollectionSelector({ productSelectorHook, localization, resetCustomization, store }) {
  const { collections, selectedCollection, setCollection, initProductSelector } =
    productSelectorHook || useCEProductSelector({ localization });

  const { isLoadingCustomization, customizationName, customizationNumber } = store || {};
  const isSwitchingCollectionRef = useRef(false);
  const animationTimingsRef = useRef({ stepMs: 50, durationMs: 0 });

  useEffect(() => {
    const style = getComputedStyle(document.documentElement);
    animationTimingsRef.current = {
      stepMs: parseFloat(style.getPropertyValue('--ce-char-step-ms')) || 50,
      durationMs: parseFloat(style.getPropertyValue('--ce-char-duration-ms')) || 0,
    };
  }, []);

  useEffect(() => {
    if (isLoadingCustomization === false) {
      const prevTotal = (customizationName?.length || 0) + (customizationNumber ? `${customizationNumber}`.length : 0);
      let hideTime = 0;

      if (prevTotal > 0) {
        const { stepMs, durationMs } = animationTimingsRef.current;
        hideTime = (prevTotal - 1) * stepMs + durationMs;
      }
      setTimeout(() => {
        isSwitchingCollectionRef.current = false;
      }, hideTime);
    }
  }, [isLoadingCustomization, customizationName, customizationNumber]);

  // Initialize data on mount
  useEffect(() => {
    if (!collections || collections.length === 0) {
      initProductSelector({ localization });
    }
  }, [initProductSelector, collections, localization]);

  return (
    <div className="collection-selector">
      <div className="collection-selector__list">
        {collections.map((collection) => (
          <button
            key={collection.id}
            className={`collection-selector__item ${selectedCollection?.id === collection.id ? 'collection-selector__item--selected' : ''}`}
            disabled={isLoadingCustomization !== false}
            onClick={() => {
              if (selectedCollection?.id === collection.id) return;
              if (isSwitchingCollectionRef.current) return;

              isSwitchingCollectionRef.current = true;
              setCollection(collection);
            }}
          >
            <div className="collection-selector__image-wrapper">
              {collection.image?.url && (
                <img
                  src={`${collection.image.url}&width=120&height=120`}
                  alt={collection.image.altText || collection.title}
                  className="collection-selector__image"
                  loading="lazy"
                />
              )}
            </div>
            <span className="collection-selector__label">{collection.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
